<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><a id="pagev"></a>CONTENTS</h1>
<p class="toc-preface" id="toc-copyright"><span href="#/copyright" title="Link target outside of Sample">Copyright</span></p>
<p class="toc-preface" id="toc-introduction"><a href="#/introduction">Introduction to Envy (T. S. Berczynski)</a></p>
<p class="toc-part" id="toc-part001"><a href="#/part001">Olesha // Envy</a></p>
<p class="toc-chapter" id="toc-chapter001"><a href="#/chapter001">Chapter I</a></p>
<p class="toc-chapter" id="toc-chapter002"><a href="#/chapter002">Chapter II</a></p>
<p class="toc-chapter" id="toc-chapter003"><a href="#/chapter003">Chapter III</a></p>
<p class="toc-chapter" id="toc-chapter004"><span href="#/chapter004" title="Link target outside of Sample">Chapter IV</span></p>
<p class="toc-chapter" id="toc-chapter005"><span href="#/chapter005" title="Link target outside of Sample">Chapter V</span></p>
<p class="toc-chapter" id="toc-chapter006"><span href="#/chapter006" title="Link target outside of Sample">Chapter VI</span></p>
<p class="toc-chapter" id="toc-chapter007"><span href="#/chapter007" title="Link target outside of Sample">Chapter VII</span></p>
<p class="toc-chapter" id="toc-chapter008"><span href="#/chapter008" title="Link target outside of Sample">Chapter VIII</span></p>
<p class="toc-chapter" id="toc-chapter009"><span href="#/chapter009" title="Link target outside of Sample">Chapter IX</span></p>
<p class="toc-chapter" id="toc-chapter010"><span href="#/chapter010" title="Link target outside of Sample">Chapter X</span></p>
<p class="toc-chapter" id="toc-chapter011"><span href="#/chapter011" title="Link target outside of Sample">Chapter XI</span></p>
<p class="toc-chapter" id="toc-chapter012"><span href="#/chapter012" title="Link target outside of Sample">Chapter XII</span></p>
<p class="toc-chapter" id="toc-chapter013"><span href="#/chapter013" title="Link target outside of Sample">Chapter XIII</span></p>
<p class="toc-chapter" id="toc-chapter014"><span href="#/chapter014" title="Link target outside of Sample">Chapter XIV</span></p>
<p class="toc-chapter" id="toc-chapter015"><span href="#/chapter015" title="Link target outside of Sample">Chapter XV</span></p>
<p class="toc-part" id="toc-part002"><span href="#/part002" title="Link target outside of Sample">Part Two</span></p>
<p class="toc-chapter" id="toc-chapter016"><span href="#/chapter016" title="Link target outside of Sample">Chapter I</span></p>
<p class="toc-chapter" id="toc-chapter017"><span href="#/chapter017" title="Link target outside of Sample">Chapter II</span></p>
<p class="toc-chapter" id="toc-chapter018"><span href="#/chapter018" title="Link target outside of Sample">Chapter III</span></p>
<p class="toc-chapter" id="toc-chapter019"><span href="#/chapter019" title="Link target outside of Sample">Chapter IV</span></p>
<p class="toc-chapter" id="toc-chapter020"><span href="#/chapter020" title="Link target outside of Sample">Chapter V</span></p>
<p class="toc-chapter" id="toc-chapter021"><span href="#/chapter021" title="Link target outside of Sample">Chapter VI</span></p>
<p class="toc-chapter" id="toc-chapter022"><span href="#/chapter022" title="Link target outside of Sample">Chapter VII</span></p>
<p class="toc-chapter" id="toc-chapter023"><span href="#/chapter023" title="Link target outside of Sample">Chapter VIII</span></p>
<p class="toc-chapter" id="toc-chapter024"><span href="#/chapter024" title="Link target outside of Sample">Chapter IX</span></p>
<p class="toc-chapter" id="toc-chapter025"><span href="#/chapter025" title="Link target outside of Sample">Chapter X</span></p>
<p class="toc-chapter" id="toc-chapter026"><span href="#/chapter026" title="Link target outside of Sample">Chapter XI</span></p>
<p class="toc-chapter" id="toc-chapter027"><span href="#/chapter027" title="Link target outside of Sample">Chapter XII</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?12526bb4